const getFirstTwo = (word) => word.slice(0, 2);

export default getFirstTwo;
